import { useUIStore } from '@uofu-uss-gis/ui-react';
import { useTheme } from '@mui/material/styles';
import { decodeDays, getBuildingIcon } from '../../utils/classUtils';

interface ClassRowProps {
  classInfo: any;
  index: number;
}

const ClassRow = ({ classInfo, index }: ClassRowProps) => {
  const { setMyClassesDetailOpen, setSelectedClassIndex } = useUIStore();
  const theme = useTheme();
  const { attributes } = classInfo;

  const courseShort = attributes.UU_COURSE_TITLE.split(' - ')[0];
  const courseLong = attributes.UU_COURSE_TITLE.split(' - ')[1];
  const days = decodeDays(attributes.UU_CRSE_DAYS);
  const startEnd = attributes.UU_CRS_STRT_END_TM;
  const bldgCd = attributes.BLDG_CD.trim();
  const imgPath = getBuildingIcon(bldgCd, index, theme.palette.mode === 'dark');

  const handleClick = () => {
    setSelectedClassIndex(index);
    setMyClassesDetailOpen(true);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full p-3 border-b cursor-pointer flex items-center gap-3 text-left"
      style={{ borderColor: theme.palette.divider }}
      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = theme.palette.action?.hover ?? 'rgba(0,0,0,0.04)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
      aria-label={`${courseShort} ${courseLong} ${days} ${startEnd}`}
    >
      <div className="w-10 h-10 flex-shrink-0">
        <img
          src={`/app/resources/images/${imgPath}.svg`}
          alt={imgPath}
          width={40}
          height={40}
          className="w-full h-full object-contain"
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm truncate">{courseShort}</p>
        <p className="text-xs truncate" style={{ color: theme.palette.text.secondary }}>{courseLong}</p>
        <p className="text-xs" style={{ color: theme.palette.text.secondary }}>{days} - {startEnd}</p>
      </div>
      <div className="flex-shrink-0">
        <img
          src={`/app/resources/images/nav-arrow${theme.palette.mode === 'dark' ? '' : '-black'}.svg`}
          alt=""
          aria-hidden="true"
          width={16}
          height={16}
          className="w-4 h-4"
        />
      </div>
    </button>
  );
};

export default ClassRow;
